module.exports = __webpack_public_path__ + "img/3.c449c539.jpg";